<p-dialog
  header="Feedback"
  [modal]="true"
  [(visible)]="visible"
  closable="false"
  [style]="{ width: '90%', 'max-width': '700px', height: '75%' }"
>
  <div class="content">
    <div class="body">
      <div class="input-group">
        <p-dropdown
          [options]="feedbackOptions"
          [(ngModel)]="selectedFeedback"
          optionLabel="label"
          appendTo="body"
          placeholder="Feedback Type"
        />
        <textarea
          placeholder="Enter feedback here..."
          rows="1"
          pInputTextarea
          [autoResize]="false"
          [(ngModel)]="userFeedback"
          [disabled]="!this.selectedFeedback"
        ></textarea>
      </div>
    </div>
    <div style="display: flex; flex-direction: row; justify-content: flex-end; gap: 1rem">
      <p-button label="Cancel" severity="info" [text]="true" (onClick)="closeDialog()" />
      <p-button type="submit" label="Create" severity="info" (onClick)="onSubmit()" [disabled]="!this.userFeedback" />
    </div>
  </div>
</p-dialog>
